'use strict';

export default function () {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
